export const userNavTranslations = {
  ru: {
    login: "Войти",
    balance: "Баланс",
    dashboard: "Личный кабинет",
    settings: "Настройки",
    logout: "Выйти"
  },
  en: {
    login: "Log in",
    balance: "Balance",
    dashboard: "Dashboard",
    settings: "Settings",
    logout: "Log out"
  }
};